export class ReadOnlyTextController implements ng.IController {

    private _displayedValue: string;
    private _defaultPlaceholderValue: string = '--';

    value: any;
    defaultValue: string;
    placeholder: string;
    isNumber: boolean = false;
    numberOfDecimalPlaces: number = 0;
    removeMargin: boolean = false;
    isDisabled: boolean = false;

    $onInit() { };

    get displayedValue(): string {

        if (this.isNumber)
            return this.getNumberValue();
        else
            return this.getStringValue();
    }

    private getStringValue(): string {

        if (this.value === null || this.value === undefined || this.value === this.defaultValue) {
            return this.placeholder !== undefined ? this.placeholder : this._defaultPlaceholderValue;
        } else {
            return this.value;
        }
    }

    private getNumberValue(): string {

        let defaultValueToCompare = this.defaultValue;
        let valueToCompare = this.value;

        if (this.numberOfDecimalPlaces != null && this.numberOfDecimalPlaces != undefined) {
            defaultValueToCompare = Number(this.defaultValue).toFixed(this.numberOfDecimalPlaces);
            valueToCompare = Number(this.value).toFixed(this.numberOfDecimalPlaces);
        }
        
        if (this.value === null || this.value === undefined || valueToCompare === defaultValueToCompare) {
            return this.placeholder !== undefined ? this.placeholder : this._defaultPlaceholderValue;
        } else {
            return this.value;
        }
    }

    get displayAsNumber(): boolean {

        let placeholderToCompare = this.placeholder !== undefined ? this.placeholder : this._defaultPlaceholderValue;

        return this.isNumber && this.displayedValue !== placeholderToCompare;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/readOnlyText/controllers/readOnlyTextController.ts
 **/